/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from "rxjs";

@Injectable()
export class EndpointService {
  private headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

  constructor(private httpClient: HttpClient) {
  }

  get(url: any): Observable<any> {
    return this.httpClient.get(url);
  }

  save(url: any, resource: any): Observable<any> {
    return this.httpClient.post(url, resource, {headers: this.headers});
  }

  put(url: any, resource: any): Observable<any> {
    return this.httpClient.put(url, resource, {headers: this.headers});
  }

  delete(url: any): Observable<any> {
    return this.httpClient.delete(url, {headers: this.headers});
  }
}

